/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Media_Loading_StatusInputs */

const en_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading media...`)
};

const fr_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des medias...`)
};

const de_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien werden geladen...`)
};

const it_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del contenuto multimediale...`)
};

const ru_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка медиафайлов...`)
};

const es_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando medios...`)
};

const zh_cn2_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载媒体……`)
};

const ja_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアを読み込んでいます...`)
};

const hi_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया लोड हो रहा है...`)
};

const pt_pt2_iframe_remote_media_loading_status = /** @type {(inputs: Iframe_Remote_Media_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando mídia...`)
};

/**
* | output |
* | --- |
* | "Loading media..." |
*
* @param {Iframe_Remote_Media_Loading_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_media_loading_status = /** @type {((inputs?: Iframe_Remote_Media_Loading_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Media_Loading_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_media_loading_status(inputs)
	if (locale === "de") return de_iframe_remote_media_loading_status(inputs)
	if (locale === "it") return it_iframe_remote_media_loading_status(inputs)
	if (locale === "ru") return ru_iframe_remote_media_loading_status(inputs)
	if (locale === "es") return es_iframe_remote_media_loading_status(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_media_loading_status(inputs)
	if (locale === "ja") return ja_iframe_remote_media_loading_status(inputs)
	if (locale === "hi") return hi_iframe_remote_media_loading_status(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_media_loading_status(inputs)
	return en_iframe_remote_media_loading_status(inputs)
});